import React from "react";
import { AxlMiniGroupAssignments } from "axl-reactjs-ui";
import { Container, Col, Row } from "./styles";
import AxlMiniJobBox from "../../../components/AxlMiniJobBox";
import AxlPagination from "../../../components/AxlPagination";
import styles, * as E from "./styles";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";


@inject("jobStore")
@observer
class ListJobsUpload extends React.Component {
  constructor(props) {
    super(props);

    this.keys = {};
  }

  onSelectJob = (job) => {
    const { jobStore } = this.props;
    // jobStore.selectedJob = job;
    if (!jobStore.isProcessing(job.status)) {
      this.props.history.push(`/batch/${job.id}`);
    }
  };

  onSelectPage = (page) => {
    const { jobStore } = this.props;
    jobStore.page = page;
    jobStore.getFinalizeJobs();
  };

  render() {
    const { jobStore } = this.props;
    const {
      reviewJobs,
      processingJobs,
      finalizedJobs,
      totalFinalizeJob,
      total_finalize_job_page,
      page,
      size,
    } = jobStore;

    const selectedJob = null;
    const listJobUpload = [
      { status: "UPLOADING", color: "#bebfc0", jobs: processingJobs },
      { status: "NEEDS REVIEW", color: "#fbc04f", jobs: reviewJobs },
      {
        status: "FINALIZED",
        color: "#887fff",
        jobs: finalizedJobs,
        total: totalFinalizeJob,
      },
    ];

    const displayBarStatuses = [
      "CREATED",
      "GEOCODE_PREPARED",
      "GEOCODE_RESPONDED",
      "GEOCODE_PROCESSED",
    ];
    const percentMap = {
      CREATED: 5,
      GEOCODE_PREPARED: 20,
      GEOCODE_RESPONDED: 90,
      GEOCODE_PROCESSED: 95,
    };

    const displayStatusMap = {
      GEOCODE_PREPARED: "GEOCODING",
      GEOCODE_RESPONDED: "GEOCODING",
      GEOCODE_PROCESSED: "GEOCODING",
      GEOCODE_FAILED: "GEOCODED",
    };

    return (
      <E.Contain>
        <E.List>
          {listJobUpload.map((item, index) => (
            <AxlMiniGroupAssignments
              indicator={false}
              key={index}
              length={
                item.total !== undefined
                  ? item.total
                  : item.jobs
                  ? item.jobs.length
                  : "0"
              }
              color={item.color}
              text={item.status}
              style={styles.panel}
            >
              {item.jobs &&
                Array.from(Array(Math.ceil(item.jobs.length / 4)).keys()).map(
                  (i) => {
                    return (
                      <Container key={`container-${i}`}>
                        <Row>
                          {[0, 1, 2, 3].map((j) => {
                            const realIndex = i * 4 + j;
                            if (realIndex < item.jobs.length) {
                              const job = item.jobs[realIndex];
                              return (
                                <Col key={`col-${j}`}>
                                  <AxlMiniJobBox
                                    onSelectJob={this.onSelectJob}
                                    key={i}
                                    job={job}
                                    status={
                                      displayStatusMap[job.status]
                                        ? displayStatusMap[job.status]
                                        : job.status
                                    }
                                    displayProgressBar={displayBarStatuses.includes(
                                      job.status
                                    )}
                                    percent={
                                      job.percent
                                        ? job.percent
                                        : percentMap[job.status]
                                    }
                                    containerStyle={{ margin: 0 }}
                                    style={{
                                      opacity:
                                        !selectedJob ||
                                        selectedJob.id === job.id
                                          ? 1.0
                                          : 0.5,
                                    }}
                                  />
                                </Col>
                              );
                            } else {
                              return <Col key={`col-${j}`}></Col>;
                            }
                          })}
                        </Row>
                      </Container>
                    );
                  }
                )}
              {/*{item.jobs && item.jobs.map((job, i) => {*/}
              {/*if (i % 4 === 0) {*/}
              {/*<Container>*/}
              {/*<Row>*/}
              {/*<Col>*/}
              {/*<AxlMiniJobBox*/}
              {/*onSelectJob={this.onSelectJob}*/}
              {/*key={i}*/}
              {/*job={job}*/}
              {/*status={displayStatusMap[job.status] ? displayStatusMap[job.status] : job.status}*/}
              {/*displayProgressBar={displayBarStatuses.includes(job.status)}*/}
              {/*percent={job.percent ? job.percent : percentMap[job.status]}*/}
              {/*style={{opacity: !selectedJob || selectedJob.id === job.id ? 1.0 : 0.5 }} />*/}
              {/*</Col>*/}

              {/*}*/}

              {/*return <AxlMiniJobBox*/}
              {/*onSelectJob={this.onSelectJob}*/}
              {/*key={i}*/}
              {/*job={job}*/}
              {/*status={displayStatusMap[job.status] ? displayStatusMap[job.status] : job.status}*/}
              {/*displayProgressBar={displayBarStatuses.includes(job.status)}*/}
              {/*percent={job.percent ? job.percent : percentMap[job.status]}*/}
              {/*style={{opacity: !selectedJob || selectedJob.id === job.id ? 1.0 : 0.5 }} />*/}
              {/*})}*/}
            </AxlMiniGroupAssignments>
          ))}
        </E.List>
        {total_finalize_job_page && total_finalize_job_page > 0 && (
          <E.PageContainer>
            <AxlPagination
              onSelect={this.onSelectPage}
              current={page}
              total={total_finalize_job_page}
              controls
            ></AxlPagination>
          </E.PageContainer>
        )}
      </E.Contain>
    );
  }
}

export default withRouter(ListJobsUpload);
